module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-bg-2-8a536ac0a2dbc0e2008b0c9327c6525f.png";